import styled, { keyframes } from 'styled-components';
import ButtonComponent from '@prisjakt/ui-button';
import { colors, layout, media } from '@prisjakt/ui-base';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const fadeInOut = keyframes`
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const Title = styled.h3`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid ${p => p.theme.lines.primary};

  svg {
    margin-right: 10px;
  }
`;

export const Button = styled(ButtonComponent)`
  width: 100%;
`;

export const ModalFooter = styled.div`
  width: 100%;
  margin-top: 5px;
  padding-top: 5px;
  border-top: solid 1px ${p => p.theme.lines.primary};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 16px;

  > svg {
    margin-right: 5px;
  }
`;

export const ReportOverlay = styled.div`
  color: ${p => p.theme.text.secondary};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 250ms ease-in-out 1;
`;

export const OverlayButton = styled(Button)`
  width: auto;

  &:not(:last-of-type) {
    margin-right: 10px;
  }

  animation: ${fadeIn} 200ms ease-in 1 backwards;

  &:nth-child(1) {
    animation-delay: 0ms;
  }
  &:nth-child(2) {
    animation-delay: 50ms;
  }
  &:nth-child(3) {
    animation-delay: 100ms;
  }
`;

export const ModalButton = styled(Button)`
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;

export const ToggleButtons = styled.button`
  color: ${p => p.theme.text.callToAction};
  text-decoration: underline;
  margin-left: 5px;
  cursor: pointer;
  color: ${colors.red1};
  white-space: nowrap;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const CloseButton = styled(ButtonComponent)`
  margin-left: ${layout.spacing.xSmall};
  flex-shrink: 0;
`;

export const Message = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
  opacity: 0;

  animation: ${fadeInOut} 3000ms ease-in-out 1;

  svg {
    margin-right: 5px;
  }
`;

export const PromptTitle = styled.span`
  ${media.smallOnly`
    display: none;
  `};
`;
